import { useState } from 'react';
import { PiPlus } from 'react-icons/pi';
import { type Task } from 'src/api/generated';
import Button from 'src/modules/shared/components/atoms/buttons/button';
import { Text } from 'src/modules/shared/components/atoms/text';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';
import Modal from 'src/modules/shared/components/molecules/modals/modal';
import { TaskPanel } from './task-panel';

interface ConversationTasksModalProps {
  isOpen: boolean;
  onClose: () => void;
  tasks: Task[];
  conversationId: number;
  subtitle?: string;
}

export const ConversationTasksModal: React.FC<ConversationTasksModalProps> = ({
  isOpen,
  onClose,
  tasks,
  conversationId,
  subtitle,
}) => {
  const { t } = useI18n();
  const [isCreatingTask, setIsCreatingTask] = useState(false);

  const handleClose = () => {
    setIsCreatingTask(false);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      header={
        <div className="flex min-w-0 flex-1 items-center gap-3">
          <div className="min-w-0 flex-1 space-y-1">
            <Text
              as="h3"
              size="h6"
              weight="semibold"
              className="text-primary-900"
            >
              {t(
                'communications.contactPanel.conversations.fields.taskModalTitle'
              )}
            </Text>
            {subtitle && (
              <Text size="small" className="truncate text-neutral-600">
                {subtitle}
              </Text>
            )}
          </div>

          <Button
            onClick={() => setIsCreatingTask((current) => !current)}
            variant="primary"
            appearance="filled"
            size="sm"
            className="ml-auto mr-2 flex flex-shrink-0 items-center gap-2 self-center font-medium"
          >
            <PiPlus className="h-4 w-4" />
            <Text size="tiny" className="hidden sm:inline">
              {t('communications.contactPanel.conversations.fields.newTask')}
            </Text>
          </Button>
        </div>
      }
      body={
        <TaskPanel
          tasks={tasks}
          conversationId={conversationId}
          isCreatingTask={isCreatingTask}
          onTaskCreated={() => setIsCreatingTask(false)}
          onTaskCancel={() => setIsCreatingTask(false)}
        />
      }
    />
  );
};
